import type { IPublicClientApplication } from '@azure/msal-browser';

export async function platformLogout(instance: IPublicClientApplication): Promise<void> {
  await instance.logoutRedirect({ postLogoutRedirectUri: '/' });
}
